// @ts-check
import {gmAPI, MapService} from '@/services/MapService';

/** @typedef {import('@/services/MapService/Map').Point} Point */

/**
 * Returns a new point that is the result of rotating the given point around the origin.
 * @param {Point} start
 * @param {number} widthDistance
 * @param {number} lengthDistance
 * @param {number} rotation
 * @return {google.maps.Point}
 */
const computeOffset = (start, widthDistance, lengthDistance, rotation) => {
  const x = start.x + lengthDistance * Math.cos(rotation) - widthDistance * Math.sin(rotation);
  const y = start.y + lengthDistance * Math.sin(rotation) + widthDistance * Math.cos(rotation);
  return new gmAPI.Point(x, y);
};

/**
 * Returns Lat/Lng coordinates for the corners of a rectangle.
 * @param {google.maps.LatLngLiteral} center The center of the rectangle on the map.
 * @param {number} length The length of rectangle in feet.
 * @param {number} width The width of rectangle in feet.
 * @param {number} rotation The rotation of the rectangle in radians.
 * @return {google.maps.LatLng[]}
 */
const getRectangle = (center, length, width, rotation) => {
  const buildingCenterXy = MapService.latLngToScreenPixel(center);
  const halfLength = MapService.feetToVerticalPixels(length / 2);
  const halfWidth = MapService.feetToHorizontalPixels(width / 2);

  const swOffset = computeOffset(buildingCenterXy, halfWidth, -halfLength, rotation);
  const nwOffset = computeOffset(buildingCenterXy, -halfWidth, -halfLength, rotation);
  const neOffset = computeOffset(buildingCenterXy, -halfWidth, halfLength, rotation);
  const seOffset = computeOffset(buildingCenterXy, halfWidth, halfLength, rotation);

  const sw = MapService.screenPixelToLatLng(swOffset.x, swOffset.y);
  const nw = MapService.screenPixelToLatLng(nwOffset.x, nwOffset.y);
  const ne = MapService.screenPixelToLatLng(neOffset.x, neOffset.y);
  const se = MapService.screenPixelToLatLng(seOffset.x, seOffset.y);

  // @ts-ignore
  return [sw, nw, ne, se];
};

export {
  getRectangle,
  computeOffset,
};
